export const LogoWithName = () => {
  return (
    <div className="flex items-center gap-3">
      <svg
        width="42"
        height="42"
        viewBox="36 -1 50 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="50.2092"
          cy="4.39704"
          rx="3.02913"
          ry="2.96942"
          transform="rotate(180 50.2092 4.39704)"
          fill="white"
        />
        <ellipse
          cx="50.1232"
          cy="37.9461"
          rx="3.02913"
          ry="2.96942"
          transform="rotate(180 50.1232 37.9461)"
          fill="white"
        />
        <ellipse
          cx="40.6115"
          cy="20.7056"
          rx="3.02913"
          ry="2.96942"
          transform="rotate(180 40.6115 20.7056)"
          fill="white"
        />
        <ellipse
          cx="42.4336"
          cy="30.8747"
          rx="2.00388"
          ry="1.96438"
          transform="rotate(180 42.4336 30.8747)"
          fill="white"
        />
        <ellipse
          cx="40.9844"
          cy="10.9939"
          rx="2.00388"
          ry="1.96438"
          transform="rotate(180 40.9844 10.9939)"
          fill="white"
        />
        <ellipse
          cx="80.6211"
          cy="10.9939"
          rx="2.00388"
          ry="1.96438"
          transform="rotate(180 80.6211 10.9939)"
          fill="white"
        />
        <ellipse
          cx="82.5547"
          cy="30.8747"
          rx="2.00388"
          ry="1.96438"
          transform="rotate(180 82.5547 30.8747)"
          fill="white"
        />
        <ellipse
          cx="82.5529"
          cy="20.7056"
          rx="3.02913"
          ry="2.96942"
          transform="rotate(180 82.5529 20.7056)"
          fill="white"
        />
        <ellipse
          cx="72.8615"
          cy="37.9464"
          rx="3.02913"
          ry="2.96942"
          transform="rotate(180 72.8615 37.9464)"
          fill="white"
        />
        <ellipse
          cx="72.9552"
          cy="4.39704"
          rx="3.02913"
          ry="2.96942"
          transform="rotate(180 72.9552 4.39704)"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.6374 4.66941C65.6353 6.13811 65.633 7.79803 66.6684 8.81309L68.5 10.6086C69.5633 11.6509 71.2567 11.6487 72.7633 11.6467C72.8285 11.6466 72.8933 11.6466 72.9576 11.6466C75.1968 11.6466 77.012 13.426 77.012 15.621C77.012 17.816 75.1968 19.5955 72.9576 19.5955C70.7185 19.5955 68.9033 17.816 68.9033 15.621C68.9033 15.5571 68.9034 15.4928 68.9035 15.4281C68.9055 13.96 68.9078 12.3006 67.8726 11.2858L66.0373 9.48669C64.9743 8.44463 63.2815 8.44681 61.7754 8.44874C61.711 8.44882 61.6469 8.4489 61.5832 8.4489C61.5194 8.4489 61.4552 8.44882 61.3907 8.44874C59.8845 8.4468 58.1916 8.44462 57.1285 9.48672L55.2999 11.2793C54.2642 12.2946 54.2666 13.9549 54.2687 15.4242C54.2688 15.4902 54.2689 15.5558 54.2689 15.621C54.2689 15.7011 54.2687 15.782 54.2685 15.8635C54.2653 17.3352 54.2617 18.9893 55.2903 20.0101L58.3216 23.0181C59.1092 23.7997 60.3746 23.799 61.4924 23.7985C61.522 23.7985 61.5514 23.7985 61.5807 23.7985C63.2536 23.7985 64.6098 25.1279 64.6098 26.7679C64.6098 28.4078 63.2536 29.7373 61.5807 29.7373C59.9078 29.7373 58.5516 28.4078 58.5516 26.7679C58.5516 25.7287 58.5484 24.5432 57.8108 23.8112L54.6176 20.6426C53.56 19.5931 51.8607 19.5943 50.3575 19.5953C50.3096 19.5954 50.262 19.5954 50.2145 19.5954C47.9754 19.5954 46.1602 17.816 46.1602 15.621C46.1602 13.4259 47.9754 11.6465 50.2145 11.6465C50.2776 11.6465 50.3411 11.6466 50.4049 11.6467C51.9104 11.6486 53.6028 11.6507 54.6656 10.6089L56.498 8.81256C57.5334 7.79754 57.5311 6.13771 57.529 4.6691C57.5289 4.60381 57.5288 4.53891 57.5288 4.47445C57.5288 2.27942 59.344 0.5 61.5832 0.5C63.8224 0.5 65.6376 2.27942 65.6376 4.47445C65.6376 4.53901 65.6375 4.60402 65.6374 4.66941ZM57.5336 37.811C57.5356 36.3423 57.538 34.6823 56.5025 33.6673L54.6706 31.8715C53.6077 30.8296 51.9151 30.8317 50.4093 30.8336C50.3452 30.8337 50.2814 30.8338 50.218 30.8338C47.9788 30.8338 46.1636 29.0544 46.1636 26.8594C46.1636 24.6643 47.9788 22.8849 50.218 22.8849C52.4572 22.8849 54.2724 24.6643 54.2724 26.8594C54.2724 26.9242 54.2723 26.9895 54.2722 27.0552C54.2701 28.5242 54.2677 30.1843 55.3033 31.1995L57.1336 32.9937C58.1966 34.0357 59.8895 34.0336 61.3955 34.0316C61.46 34.0316 61.524 34.0315 61.5877 34.0315C61.6515 34.0315 61.7157 34.0316 61.7803 34.0316C63.2864 34.0336 64.9794 34.0358 66.0424 32.9937L67.871 31.2011C68.9068 30.1858 68.9044 28.5254 68.9022 27.0562C68.9021 26.9902 68.9021 26.9246 68.9021 26.8594C68.9021 26.7792 68.9022 26.6984 68.9024 26.6169C68.9056 25.1451 68.9092 23.491 67.8806 22.4703L64.849 19.462C64.0615 18.6804 62.7961 18.6811 61.6783 18.6816C61.6489 18.6816 61.6195 18.6816 61.5903 18.6816C59.9173 18.6816 58.5611 17.3522 58.5611 15.7122C58.5611 14.0723 59.9173 12.7428 61.5903 12.7428C63.2632 12.7428 64.6194 14.0723 64.6194 15.7122C64.6194 16.7515 64.6225 17.9371 65.3602 18.6692L68.5533 21.8378C69.6109 22.8873 71.3102 22.8861 72.8135 22.885C72.8613 22.885 72.909 22.885 72.9564 22.885C75.1956 22.885 77.0108 24.6644 77.0108 26.8594C77.0108 29.0544 75.1956 30.8339 72.9564 30.8339C72.8933 30.8339 72.8299 30.8338 72.7661 30.8337C71.2605 30.8318 69.5681 30.8297 68.5054 31.8715L66.6729 33.6678C65.6375 34.6828 65.6398 36.3427 65.6419 37.8113C65.642 37.8766 65.6421 37.9415 65.6421 38.0059C65.6421 40.2009 63.8269 41.9804 61.5877 41.9804C59.3486 41.9804 57.5334 40.2009 57.5334 38.0059C57.5334 37.9414 57.5335 37.8763 57.5336 37.811Z"
          fill="white"
        />
      </svg>
      <span className="font-lexend text-[24px] font-normal leading-[1.3] tracking-[-0.02em] text-white">
        syncara
      </span>
    </div>
  );
};
